import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyQineticPaymentSource } from 'src/app/core/company-qinetic-payment-source.service';
import { CompanyStripePaymentSource } from 'src/app/core/company-stripe-payment-source.service';

@Component({
  selector: 'app-company-details-general-payment-methods',
  templateUrl: './company-details-general-payment-methods.component.html',
  styleUrls: ['./company-details-general-payment-methods.component.scss'],
})
export class CompanyDetailsGeneralPaymentMethodsComponent {
  @Input() qinetic_payment_sources?: CompanyQineticPaymentSource[];
  @Input() stripe_payment_sources?: CompanyStripePaymentSource[];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
}
